import SingleManageUserId from './SingleManageUserId';

export default SingleManageUserId;
